import React from "react";
import "./containers.css";
import ModalImage from "react-modal-image";
import { ReferenceCard, ResourceCard } from "../../atoms/cards/Cards";

const ServicesContainer = ({ callback, text, active = false }) => {
  return (
    <div
      className={`service-title ${active ? "active-service" : null}`}
      onClick={callback}
    >
      {text}
    </div>
  );
};

const ProductContainer = ({ product }) => {
  const defaultText = "Marcas líderes para la industria del mueble y la madera";

  const arrayToString = (array) => {
    let aux = "";
    for (let arr of array) {
      if (aux === "") {
        aux = arr;
      } else {
        aux = `${aux}, ${arr}`;
      }
    }

    return aux;
  };

  return (
    <>
      <div className="active-service-title">{product.product}</div>
      <br />

      {product.principal_image !== undefined ? (
        <ModalImage
          small={product.principal_image}
          large={product.principal_image}
          alt={product.product}
          className="product-principal-img"
        />
      ) : null}

      <div className="active-service-description">
        {product.description !== undefined ? product.description : defaultText}
      </div>

      {product.references !== undefined ? (
        <div className="references-container">
          {product.references.map((reference) => (
            <ReferenceCard reference={reference} />
          ))}
        </div>
      ) : null}

      {product.contains_format ? (
        <>
          <table>
            {Object.keys(product.format).map((name) =>
              product?.format[name] ? (
                <tr>
                  <td className="table-title">
                    {name === "measures"
                      ? "Medidas"
                      : name === "gauges"
                      ? "Calibres"
                      : "Referencias"}
                  </td>
                  <td>{arrayToString(product.format[name])}</td>
                </tr>
              ) : null
            )}
          </table>
          <br />
        </>
      ) : null}

      {product.contains_customers ? (
        <h1 className="h1-customer">Proveedores</h1>
      ) : null}

      {product.contains_customers
        ? product.customers.map((customer) => (
            <div className="customer-main-container">
              <img
                src={customer.avatar}
                className="customer-avatar"
                alt={customer.avatar}
              />
              {/* {customer.series.map((serie) => (
                <>
                  <div className="serie-title">{serie.title}</div>
                  <div className="resource-container">
                    {serie.resources.map((resource) => (
                      <ResourceCard resource={resource} />
                    ))}
                  </div>
                </>
              ))} */}
            </div>
          ))
        : null}
    </>
  );
};

export { ServicesContainer, ProductContainer };
